import "./styles.css"

function Paralax() {
    return (
        <div className="bg-fundo">
            <p className="title" >Venha nos conhecer <i className="fas fa-grin-wink"></i></p>
            <p className="sub-title">Há pets procurando um lar<br /> e que tal deixar eles bagunçarem sua vida?<br />
            </p>
        </div>
    )
}

export default Paralax;